import { render, staticRenderFns } from "./cat-ii-requirement.vue?vue&type=template&id=6bfc59d6&scoped=true"
import script from "./cat-ii-requirement.vue?vue&type=script&lang=js"
export * from "./cat-ii-requirement.vue?vue&type=script&lang=js"
import style0 from "./cat-ii-requirement.vue?vue&type=style&index=0&id=6bfc59d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc59d6",
  null
  
)

export default component.exports